import * as React from 'react';
import PromptDialog from './PromptDialog';

export interface PromptTextProps {
  open: boolean;
  title: string | null;
  message: string | null;
  textLabel: string | null;
  acceptText: string;
  rejectText: string;
  proceed: ((value: string) => void) | null;
  reject: ((reason?: string) => void) | null;
}

export const initialState: PromptTextProps = {
  open: false,
  title: null,
  message: null,
  textLabel: null,
  acceptText: 'Accept',
  rejectText: 'Reject',
  proceed: null,
  reject: null,
};

export const PromptTextContext = React.createContext<
  [PromptTextProps, React.Dispatch<React.SetStateAction<PromptTextProps>>] | undefined
>(undefined);

export default function PromptTextProvider({ children }: any) {
  const [promptText, setPromptText] = React.useState<PromptTextProps>(initialState);

  return (
    <PromptTextContext.Provider value={[promptText, setPromptText]}>
      {children}
      <PromptDialog promptText={promptText} />
    </PromptTextContext.Provider>
  );
}
